import GlassCard from '@/components/GlassCard';
import React from 'react';

interface EmptyStateProps {
    icon?: React.ElementType;
    title?: string;
    description: React.ReactNode;
    action?: React.ReactNode;
    className?: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({
    icon: Icon,
    title,
    description,
    action,
    className = '',
}) => {
    return (
        <GlassCard className={`p-8 shadow-lg ${className}`}>
            <div className="py-12 text-center">
                {Icon && (
                    <Icon className="mx-auto mb-4 h-12 w-12 text-gray-400 dark:text-neutral-500" />
                )}
                {title && (
                    <h3 className="mb-2 text-2xl font-semibold text-gray-900 dark:text-white">
                        {title}
                    </h3>
                )}
                <p className="text-lg text-gray-600 dark:text-neutral-400">
                    {description}
                </p>
                {action && <div className="mt-6">{action}</div>}
            </div>
        </GlassCard>
    );
};

export default EmptyState;
